import React from "react";
import { Skeleton } from "@mui/lab";

import { StyledTableCell, StyledTableRow } from "../../containers/AuditLogs/styles";

const AppSkeleton = ({ widths, rowCount = 7, height = 15 }) => {
  const rows = Array(rowCount).fill(0);

  return (
    <>
      {rows.map((elem, index) => (
        <StyledTableRow key={`${elem}_${index}`}>
          {widths.map((width, index) => (
            <StyledTableCell key={`${width}_${index}`} component="th" scope="row">
              <Skeleton variant="text" width={width} height={height} />
            </StyledTableCell>
          ))}
        </StyledTableRow>
      ))}
    </>
  );
};

export { AppSkeleton };
